module.exports = __webpack_public_path__ + "static/media/booking-cancel.0aea8879.mp3";